module.exports = require("cookie-universal");